import { DESKTOP_APP_UPDATER_URL } from 'constants/api';

const useDownloadDesktopApp = () => {
  const getUrl = (os: 'macos' | 'windows') => `${DESKTOP_APP_UPDATER_URL}/${os}?format=bundle`;
  const download = (os: 'macos' | 'windows') => window.open(getUrl(os), '_blank');

  return {
    download,
    getUrl,
  };
};

export default useDownloadDesktopApp;
